import { CartConfig } from '@spartacus/cart/base/root';

export const customCartConfig: CartConfig = {
  cart: {
    validation: {
      enabled: true,
    },
  },
};
